<div *ngIf="!!entryId && hasContent" class="flex justify-content-between" style="flex-flow: row wrap">
  <ng-template ngFor let-row [ngForOf]="allAttachments">
    <div class="attachment-row">
      <ng-container *ngFor="let eaConfig of row">
        <div
          style.width="{{ eaConfig.width ? eaConfig.width : '100%' }}"
          style.minWidth="{{ eaConfig.minWidth ? eaConfig.minWidth : '0' }}"
          style.max-width="{{ eaConfig.maxWidth ? eaConfig.maxWidth : 'none' }}"
          class="attachment-item"
        >
          <ng-template ngFor let-appearance [ngForOf]="eaConfig.elements">
            <div
              class="attachment-element"
              [class.transparent-bg]="!!appearance.box"
              [class.auto-height]="!!appearance.tabView"
            >
              <!-- ### Box ### -->
              <ng-container *ngIf="!!appearance.box">
                <ng-template ngFor let-element [ngForOf]="appearance.box">
                  <div
                    *ngIf="(getElementVisibility$(element) | async) && !this.excludedPanels?.includes(element.name)"
                    [style]="{ height: element.height }"
                  >
                    <ng-container
                      *ngTemplateOutlet="entityAttachments; context: { entityAttachment: element }"
                    ></ng-container>
                  </div>
                </ng-template>
              </ng-container>

              <!-- ### Panels ### -->
              <ng-container *ngIf="!!appearance.panel">
                <ng-template ngFor let-element [ngForOf]="appearance.panel">
                  <!-- Only allow the panel to fill the remaining height if the attachment supports this.
                                        Attachments with static height would just fill the panel with an empty white space without this check -->
                  <!-- <p-panel [header]="element.displayName" [style]="{'height': element.height}" [class.panel-fill-height]="hasFlexibleHeight(element)" [toggleable]="true">
                                        <ng-container *ngTemplateOutlet="entityAttachments; context:{entityAttachment: element}"></ng-container>
                                    </p-panel> -->

                  <p-panel
                    *ngIf="getElementVisibility$(element) | async"
                    [header]="element.displayName"
                    [toggleable]="true"
                  >
                    <div class="p-2" [style]="{ height: element.height ? element.height : '100%' }">
                      <ng-container
                        *ngTemplateOutlet="entityAttachments; context: { entityAttachment: element }"
                      ></ng-container>
                    </div>
                  </p-panel>
                </ng-template>
              </ng-container>

              <!-- ### Tabs ### -->
              <ng-container *ngIf="!!appearance.tabView">
                <jml-lib-tab-container
                  [tabs]="appearance.tabView"
                  [excludedPanels]="excludedPanels"
                  [configName]="configName"
                  [entryId]="entryId"
                  [refreshTrigger]="refreshTrigger"
                  [contentTemplate]="entityAttachments"
                ></jml-lib-tab-container>
              </ng-container>

              <!-- ### AutoGrid -->
              <ng-container *ngIf="!!appearance.autoGrid">
                <div class="auto-grid">
                  <ng-template ngFor let-element [ngForOf]="appearance.autoGrid">
                    <div
                      [ngSwitch]="element.type"
                      class="auto-grid__item"
                      [style.grid-column-start]="'span ' + element.gridWidth"
                      [style.grid-row-start]="'span ' + element.gridHeight"
                    >
                      <p-card [style]="{ background: element.backgroundColor, color: element.textColor }">
                        <div class="auto-grid__item__content">
                          <span class="auto-grid__item__content__header">{{ element.displayName }}</span>
                          <ng-container *ngTemplateOutlet="entityAttachments; context: { entityAttachment: element }">
                          </ng-container>
                        </div>
                      </p-card>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>

<ng-template #entityAttachments let-entityAttachment="entityAttachment">
  <ng-container [ngSwitch]="entityAttachment.type">
    <!-- Components: Notes, File Attachments, Attributes, Log Entries, Security Action Editor, FieldGroup, EntityHeader, Quick Notes -->
    <ng-container *ngSwitchCase="'component'">
      <ng-container [ngSwitch]="entityAttachment.name">
        <jml-lib-entity-notes
          *ngSwitchCase="'Notes'"
          [ownerType]="configName"
          [ownerId]="entryId"
        ></jml-lib-entity-notes>
        <jml-lib-entity-file-attachments
          *ngSwitchCase="'FileAttachments'"
          [ownerType]="configName"
          [ownerId]="entryId"
          [categories]="entityAttachment.attachmentCategories"
        ></jml-lib-entity-file-attachments>
        <jml-lib-entity-attributes
          *ngSwitchCase="'Attributes'"
          [ownerType]="configName"
          [ownerId]="entryId"
        ></jml-lib-entity-attributes>
        <jml-lib-entity-generic-attachments
          *ngSwitchCase="'LogEntries'"
          [ownerType]="configName"
          [ownerId]="entryId"
          attachmentType="LogEntry"
        ></jml-lib-entity-generic-attachments>
        <jml-lib-right-actions-editor
          *ngSwitchCase="'SecurityActionEditor'"
          [ownerId]="entryId"
        ></jml-lib-right-actions-editor>
        <jml-lib-entity-header
          *ngSwitchCase="'EntityHeader'"
          [refreshTrigger]="refreshTrigger"
          [configName]="configName"
        ></jml-lib-entity-header>
        <jml-lib-entity-quick-notes
          *ngSwitchCase="'QuickNotes'"
          [ownerType]="configName"
          [ownerId]="entryId"
        ></jml-lib-entity-quick-notes>
        <jml-lib-entity-actions
          *ngSwitchCase="'Actions'"
          [configuration]="configuration"
          [entityId]="entryId"
          [orientation]="entityAttachment.orientation"
        ></jml-lib-entity-actions>
        <jml-lib-script-actions *ngSwitchCase="'ScriptTester'"></jml-lib-script-actions>
        <jml-lib-entity-name
          *ngSwitchCase="'EntityName'"
          [entityType]="configName"
          [entityId]="entryId"
          [displayHeader]="entityAttachment.displayName"
          [displayDescription]="entityAttachment.displayDescription"
        ></jml-lib-entity-name>
        <jml-lib-entity-generic-attachments
          *ngSwitchCase="'Attachments'"
          [attachmentType]="entityAttachment.attachmentType"
          [ownerType]="configName"
          [ownerId]="entryId"
        ></jml-lib-entity-generic-attachments>
        <jml-lib-fields-filter
          *ngSwitchCase="'FieldSubset'"
          [refreshTrigger]="refreshTrigger"
          [entityId]="entryId"
          [dtoType]="configName"
        ></jml-lib-fields-filter>
      </ng-container>
    </ng-container>

    <!-- Sub Entities -->
    <div *ngSwitchCase="'subEntity'">
      <jml-lib-entity-subtypes
        [subtype]="entityAttachment.name"
        [mainType]="configName"
        [mainId]="entryId"
        [mainRepr]="entryRepr"
        [refreshTrigger]="refreshTrigger"
      ></jml-lib-entity-subtypes>
    </div>

    <!-- Group Relations -->
    <div *ngSwitchCase="'group'">
      <jml-lib-entity-group-relation
        [holderId]="entryId"
        [relation]="entityAttachment.name"
      ></jml-lib-entity-group-relation>
    </div>

    <!-- Field Groups -->
    <div *ngSwitchCase="'fieldGroup'">
      <jml-lib-entity-field-group
        [attachmentComponent]="entityAttachment"
        [refreshTrigger]="refreshTrigger"
      ></jml-lib-entity-field-group>
    </div>

    <!-- Code Editor -->
    <jml-lib-code-wrapper
      *ngSwitchCase="'codeEditor'"
      [dtoType]="configName"
      [entityId]="entryId"
      [syntax]="entityAttachment.syntax"
      [fieldName]="entityAttachment.field"
      [refreshTrigger]="refreshTrigger"
    >
    </jml-lib-code-wrapper>

    <ng-container *ngSwitchCase="'dashlet'">
      <ng-container [ngSwitch]="entityAttachment.dashlet.type">
        <jml-lib-tile-dashlet
          *ngSwitchCase="'tile'"
          [dashlet]="entityAttachment.dashlet"
          [entityReference]="{ dtoType: configName, id: entryId }"
        ></jml-lib-tile-dashlet>
        <jml-lib-log-dashlet
          *ngSwitchCase="'log'"
          [dashlet]="entityAttachment.dashlet"
          [entityReference]="{ dtoType: configName, id: entryId }"
        ></jml-lib-log-dashlet>
        <jml-lib-button-dashlet
          *ngSwitchCase="'button'"
          [dashlet]="entityAttachment.dashlet"
          [entityReference]="{ dtoType: configName, id: entryId }"
        ></jml-lib-button-dashlet>
        <jml-lib-chart-dashlet
          *ngSwitchCase="'chart'"
          [dashlet]="entityAttachment.dashlet"
          [entityReference]="{ dtoType: configName, id: entryId }"
          class="flex-grow-1 w-full"
        ></jml-lib-chart-dashlet>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
